module.exports = __webpack_public_path__ + "img/image4.88f9e60.png";